export default "* Samarbejde\n* Kropssprog\n* Lytte ";